import { useState } from "react";
import { Modal, SelectField, SubcategoryField } from "./AdministrationFields";
import { PATIENT_STATUS_OPTIONS } from "../model/administrationConstants";
import { normalizePatientStatus } from "../model/administrationRules";
import { errorStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { inputStyle, labelStyle } from "../styles/administrationStyles";

export function AddPatientModal({ ehpadName, productionSubcategories, onClose, onCreated }) {
    const [form, setForm] = useState({ nom: "", prenom: "", dateNaissance: "", chambre: "", productionSubcategory: "", patientStatus: "AUCUN", nir: "" });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const submit = async event => {
        event.preventDefault();
        if (!form.nom.trim() || !form.prenom.trim()) {
            setError("Le nom et le prénom sont obligatoires.");
            return;
        }
        setSaving(true);
        setError("");
        try {
            const payload = {
                nom: form.nom.trim(),
                prenom: form.prenom.trim(),
                dateNaissance: form.dateNaissance || null,
                chambre: form.chambre.trim() || null,
                productionSubcategory: form.productionSubcategory || null,
                patientStatus: normalizePatientStatus(form.patientStatus),
            };
            if (form.nir.trim()) payload.nir = form.nir.trim();
            await onCreated(payload);
        } catch (requestError) {
            setError(requestError.response?.data?.message || "Impossible d'ajouter ce patient.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal title={`Ajouter un patient${ehpadName ? ` — ${ehpadName}` : ""}`} onClose={onClose} width={520}>
            <form onSubmit={submit} style={{ display: "grid", gap: "14px" }}>
                {error && <p role="alert" style={errorStyle}>{error}</p>}
                <label style={labelStyle}>
                    <span>Nom</span>
                    <input
                        autoFocus
                        style={inputStyle}
                        value={form.nom}
                        onChange={event => setForm(current => ({ ...current, nom: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Prénom</span>
                    <input
                        style={inputStyle}
                        value={form.prenom}
                        onChange={event => setForm(current => ({ ...current, prenom: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Date de naissance</span>
                    <input
                        type="date"
                        style={inputStyle}
                        value={form.dateNaissance}
                        onChange={event => setForm(current => ({ ...current, dateNaissance: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Chambre</span>
                    <input
                        style={inputStyle}
                        value={form.chambre}
                        onChange={event => setForm(current => ({ ...current, chambre: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    Sous-catégorie (planning, production, etc.) (facultatif)
                    <SubcategoryField
                        value={form.productionSubcategory}
                        options={productionSubcategories}
                        onChange={value => setForm(current => ({ ...current, productionSubcategory: value || "" }))}
                    />
                </label>
                <label style={labelStyle}>
                    Statut patient
                    <SelectField
                        value={form.patientStatus}
                        options={PATIENT_STATUS_OPTIONS}
                        onChange={value => setForm(current => ({ ...current, patientStatus: normalizePatientStatus(value) }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>NIR</span>
                    <input
                        style={inputStyle}
                        value={form.nir}
                        onChange={event => setForm(current => ({ ...current, nir: event.target.value }))}
                    />
                </label>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button type="button" onClick={onClose} disabled={saving} style={secondaryButtonStyle}>Annuler</button>
                    <button type="submit" disabled={saving} style={primaryButtonStyle}>
                        {saving ? "Ajout…" : "Ajouter le patient"}
                    </button>
                </div>
            </form>
        </Modal>
    );
}
